var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'AutoMarketingList'
      }
    }
  }, [_vm._v("行銷自動化")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("行銷自動化列表")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-2 mb-2 font-weight-bold"
  }, [_vm._v("行銷自動化列表")]), _c('div', {
    staticClass: "\n        col-12 col-xl-6 mb-2\n        d-flex\n        flex-xl-row\n        align-items-start align-items-xl-center\n        "
  }, [_vm.checkPermission([_vm.consts.MKT_CONFIG_LIST_CREATE]) ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-3",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'AutoMarketingCreate'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("新增行銷模組")]) : _vm._e(), _c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageResetWithoutReload.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageResetWithoutReload
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)]), _c('div', {
    staticClass: "d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('div', {
    staticClass: "\n          d-flex\n          flex-column flex-xl-row\n          align-items-start align-items-xl-center\n        "
  }, [_c('span', [_vm._v("設定區間：")]), _c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "value": _vm.query.start_at
    },
    on: {
      "selected": _vm.handleStartAtSelected
    }
  }), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("~")]), _c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "value": _vm.query.end_at
    },
    on: {
      "selected": _vm.handleEndAtSelected
    }
  })], 1)]), _c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.marketingConfigs,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(actions)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.MKT_CONFIG_LIST_VIEW]) ? _c('b-button', {
          attrs: {
            "variant": "inverse-primary",
            "to": {
              name: 'AutoMarketingView',
              params: {
                config_id: data.item.id
              }
            }
          }
        }, [_vm._v(" 查看 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.MKT_CONFIG_LIST_MODIFY]) ? _c('b-button', {
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'AutoMarketingEdit',
              params: {
                config_id: data.item.id
              }
            }
          }
        }, [_vm._v(" 編輯 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.MKT_CONFIG_LIST_DELETE]) ? _c('b-button', {
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteConfig(data.item);
            }
          }
        }, [_vm._v(" 刪除 ")]) : _vm._e()];
      }
    }])
  })], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }